import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/layout/Layout';
import HomePage from './components/home/HomePage';
import PortfolioPage from './components/portfolio/PortfolioPage';
import ServicesPage from './components/services/ServicesPage';
import TestimonialsPage from './components/testimonials/TestimonialsPage';
import ContactPage from './components/contact/ContactPage';
import NotFound from './components/common/NotFound';
import ScrollToTop from './components/common/ScrollToTop';
import CookieConsent from './components/common/CookieConsent';
import useAnalytics from './hooks/useAnalytics';

/**
 * Main App component
 * Sets up routing, global providers, and analytics
 */
function App() {
  // Initialize analytics hook inside Router context
  const AnalyticsWrapper = () => {
    const { handleAcceptCookies, handleDeclineCookies } = useAnalytics();
    
    return (
      <>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <CookieConsent 
          onAccept={handleAcceptCookies}
          onDecline={handleDeclineCookies}
        />
      </>
    );
  };

  return (
    <HelmetProvider>
      <Router>
        <AnalyticsWrapper />
      </Router>
    </HelmetProvider>
  );
}

export default App;
